import { Navigate } from 'react-router-dom';
import { getAuthentication } from './hooks/useAuthentication';

export enum RoutesEnum {
  DAILY_BUBBLE,
  KNOWLEDGE_HUB,
  PODCAST,
  LEARN,
  ADMIN_MANAGEMENT,
  USER_MANAGEMENT,
  REPORTING_DASHBOARD,
  SURVEY_DASHBOARD,
  MEDITATION,
  ANNOUNCEMENTS,
}

export function isAuthorized(route: RoutesEnum) {
  const { user } = getAuthentication();
  if (!user.school.subscription) return false;
  const { dailyBubble, knowledgeHub, podcast, learn, meditation } = user.school.subscription;

  switch (route) {
    case RoutesEnum.DAILY_BUBBLE:
      return dailyBubble;
    case RoutesEnum.KNOWLEDGE_HUB:
      return knowledgeHub;
    case RoutesEnum.PODCAST:
      return podcast;
    case RoutesEnum.LEARN:
      return learn;
    case RoutesEnum.MEDITATION:
      return meditation;
    case RoutesEnum.ADMIN_MANAGEMENT:
      return user?.ws_permission?.adminManagement;
    case RoutesEnum.REPORTING_DASHBOARD:
      return user?.ws_permission?.reportingDashboard;
    case RoutesEnum.SURVEY_DASHBOARD:
      return user?.ws_permission?.surveyDashboard;
    case RoutesEnum.ANNOUNCEMENTS:
      return user?.ws_permission?.announcements;
    case RoutesEnum.USER_MANAGEMENT:
      return user?.ws_permission?.userManagement;
    default:
      return false;
  }
}
export default function withAuthGuard(WrappedComponent: React.ReactNode, route: RoutesEnum) {
  const autentication = getAuthentication();

  if (!autentication || !autentication.user) {
    return <Navigate to="/login" />;
  }

  if (!isAuthorized(route)) {
    return <Navigate to="/not-authorized" />;
  }

  return WrappedComponent;
}
